<template>
  <Layout>
    <!--  <language-switch class="lang" /> -->
    <form @submit.prevent>
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-4">
                    <h3 class="text-dark">TuneSoft</h3>
                    <h5 class="text-primary">
                      {{ $t("account.reset-password-text") }}
                    </h5>
                  </div>
                </div>

                <div class="col-5 align-self-end">
                  <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div>
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img :src="whiteLabel || require('@/assets/images/logo-small.png')" height="60" />
                  </span>
                </div>
              </div>

              <div>
                <sweet-input
                  :isValid="!$v.form.password.$error"
                  @input="$v.form.password.$touch()"
                  v-model="form.password"
                  type="password"
                  layout="vertical"
                  inputClass="mt"
                  :placeholder="$t('auth.placeholder.password')"
                  :label="$t('common.password')"
                  class="{
                  'is-invalid': submitted && $v.form.password.$error,
                  'is-valid': submitted && !$v.form.password.$error,
                }"
                />
              </div>

              <div v-if="$v.form.password.$error" class="text-danger">
                <div v-if="!$v.form.password.required">
                  {{ $t("validation.password.required") }}
                </div>
                <div v-else-if="!$v.form.password.containsUppercase">
                  {{ $t("validation.password.uppercase") }}
                </div>
                <div v-else-if="!$v.form.password.containsLowercase">
                  {{ $t("validation.password.lowercase") }}
                </div>
                <div v-else-if="!$v.form.password.containsNumber">
                  {{ $t("validation.password.number") }}
                </div>
                <div v-else-if="!$v.form.password.containsSpecial">
                  {{ $t("validation.password.special") }}
                </div>
                <div v-else-if="!$v.form.password.minLength">
                  {{ $t("validation.password.minlength") }}
                </div>
                <div v-else-if="!$v.form.password.maxLength">
                  {{ $t("validation.password.maxlength") }}
                </div>
              </div>

              <div>
                <sweet-input
                  :isValid="!$v.form.confirmPassword.$error"
                  @input="$v.form.confirmPassword.$touch()"
                  v-model="form.confirmPassword"
                  type="password"
                  layout="vertical"
                  inputClass="mt"
                  :placeholder="$t('auth.placeholder.repeat-password')"
                  :label="$t('common.password')"
                  labelClass="mt-2"
                  class="{
                  'is-invalid': submitted && $v.form.confirmPassword.$error,
                  'is-valid': submitted && !$v.form.confirmPassword.$error,
                }"
                />
              </div>
              <div v-if="$v.form.confirmPassword.$error" class="text-danger">
                <div v-if="!$v.form.confirmPassword.required">
                  {{ $t("validation.password.required") }}
                </div>
                <div v-else-if="!$v.form.confirmPassword.sameAsPassword">
                  {{ $t("validation.password.confirm") }}
                </div>
              </div>

              <br />
              <div v-if="enableRecaptcha">
                <vue-recaptcha ref="recaptcha" @verify="handleRecaptchaVerify" :sitekey="recaptchaKey" size="invisible"> </vue-recaptcha>
                <b-button type="submit" variant="primary" class="btn-block" @click="changePassword" :disabled="$v.form.$invalid || isRequesting">
                  {{ $t("common.update") }}
                </b-button>
              </div>

              <div v-else>
                <b-button type="submit" variant="primary" class="btn-block" @click="changePassword" :disabled="$v.form.$invalid || isRequesting">
                  {{ $t("common.update") }}
                </b-button>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->

          <div class="mt-6 text-center">
            <p>
              <router-link to="/login" class="font-weight-medium text-primary">
                <i class="bx bx-lock font-size-16 align-middle"></i>
                {{ $t("common.login") }}
              </router-link>
            </p>
            <div class="mt-5 text-center">
              <p>© {{ new Date().getFullYear() }} Tunesoft</p>
            </div>
            <!-- TKP-236 n.11: "powered by Phexum" kalktı -->
          </div>

          <!-- end row -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </form>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import Layout from "@/layouts/account/auth";

import { VueRecaptcha } from "vue-recaptcha";
import { maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Reset-Password",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, VueRecaptcha },
  data() {
    return {
      form: {
        password: undefined,
        confirmPassword: undefined,
        required: undefined,
        token: this.$route.params.token,
      },
      formError: undefined,
      progress: false,
      done: false,
      submitted: false,
      isRequesting: false,
    };
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(64),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-.]/.test(value);
        },
      },
      confirmPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(64),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-.]/.test(value);
        },
        sameAsPassword: sameAs("password"),
      },
    },
  },
  computed: {
    recaptchaKey() {
      return this.$store.getters["clientConfig/recaptchaKey"];
    },
    enableRecaptcha() {
      return this.$store.getters["clientConfig/enableRecaptcha"];
    },
  },
  mounted() {
    this.token = this.$route.params.token;
  },
  methods: {
    async changePassword() {
      if (this.enableRecaptcha) {
        this.$refs.recaptcha.reset();
        this.$refs.recaptcha.execute();
      } else {
        await this.submit();
      }
    },
    async submit() {
      try {
        if (this.isRequesting) {
          return;
        }
        this.isRequesting = true;
        const response = await this.$store.dispatch("user/changePassword", this.form);
        this.$toast.success(this.$t("common.password-updated"));
        setTimeout(() => {
          this.isRequesting = false;
          window.location.href = "/login";
        }, 2000);
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
        this.isRequesting = false;
      }
    },
    async handleRecaptchaVerify(response) {
      if (response) {
        try {
          await this.submit();
        } catch (error) {
          console.error("Form submission error", error);
        }
      }
    },
  },
};
</script>
<style scoped>
.lang {
  position: absolute;
  top: 0;
  right: 1rem;
}
</style>
